import React, { FC, ReactNode, useContext, useMemo } from "react";

import classnames from "classnames";

import { AccordionContext } from "./Accordion";
import { StyledAccordionItem } from "./Styles";

export interface IAccordionItem {
  /** Children type of node or string */
  children: ReactNode;
  /** ClassName */
  className?: string;
  /** Id of the accordion item */
  id?: string;
}

export interface IItemContext {
  isItemExpanded: boolean;
  id: string;
}

export const ItemContext = React.createContext(null as IItemContext | null);

export const AccordionItem: FC<IAccordionItem> = ({
  children,
  className,
  id,
}) => {
  const accordionContext = useContext(AccordionContext);

  const itemId = useMemo(() => {
    if (!id) {
      const randomString = Math.random().toString(36).slice(2);
      return `accordion-item-${randomString}`;
    }
    return id;
  }, [id]);

  return (
    <ItemContext.Provider
      value={{
        isItemExpanded: accordionContext
          ? accordionContext.expandedItems.indexOf(itemId) > -1
          : false,
        id: itemId,
      }}
    >
      <StyledAccordionItem className={classnames("accordionItem", className)}>
        {children}
      </StyledAccordionItem>
    </ItemContext.Provider>
  );
};

AccordionItem.displayName = "AccordionItem";
